import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useTheme } from '../../context/MagicBellThemeContext.js';
import Text from '../Text/index.js';
/**
 *
 * @example
 * <EnablePushNotificationsButton onClick={enableNotifications} />
 */
export default function EnablePushNotificationsButton({ onClick }) {
    const theme = useTheme();
    const handleClick = () => {
        onClick();
    };
    return (_jsx("button", { css: css `
        padding: 10px !important;
        border-radius: 4px !important;
        background: ${theme.footer.backgroundColor} !important;
        color: ${theme.footer.textColor} !important;
      `, onClick: handleClick, children: _jsx(Text, { id: "web-push-notifications.enable-now", defaultMessage: "Enable Now" }) }));
}
//# sourceMappingURL=EnablePushNotificationsButton.js.map